export type DatePickerType = "DATE_PICKER" | "DATE_RANGE_PICKER";

export enum TimePrecision {
  NONE = "None",
  MILLISECOND = "millisecond",
  MINUTE = "minute",
  SECOND = "second",
}
